(() => {
  if (window.zaoudProductCardQuickAddBound) return;
  window.zaoudProductCardQuickAddBound = true;

  const playAddFabClick = (fab) => {
    fab.classList.remove('zaoud-product-card__quick-add-fab--clicked');
    void fab.offsetWidth;
    fab.classList.add('zaoud-product-card__quick-add-fab--clicked');
  };

  document.addEventListener('click', (event) => {
    const addFab = event.target.closest('[data-zaoud-add-to-cart-trigger]:not([disabled])');
    if (addFab) {
      event.preventDefault();
      event.stopPropagation();
      playAddFabClick(addFab);
      addFab.closest('.zaoud-product-card')?.querySelector('product-form form')?.requestSubmit();
      return;
    }

    const quickViewFab = event.target.closest('[data-zaoud-quick-view-trigger]:not([disabled])');
    if (!quickViewFab) return;

    event.preventDefault();
    event.stopPropagation();
    quickViewFab.closest('.zaoud-product-card')?.querySelector('modal-opener button:not([disabled])')?.click();
  });

  document.addEventListener(
    'animationend',
    (event) => {
      if (event.animationName !== 'zaoud-fab-add-click' && event.animationName !== 'zaoud-fab-add-click-reduced') {
        return;
      }

      event.target
        .closest?.('.zaoud-product-card__quick-add-fab--add')
        ?.classList.remove('zaoud-product-card__quick-add-fab--clicked');
    },
    true
  );
})();
